import styled from 'styled-components';

const Description = styled.div`
  margin-right: 32px;
  max-width: min(260px, 100%);
  min-width: min(260px, 100%);
`;

export default Description;
